import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import X from 'react-feather/dist/icons/x';
import { CONSTANTS } from '../../constants/constants';
import FormControl from '@mui/material/FormControl';
import { useForm } from 'react-hook-form';
import NRControlledTextField from '../NRControlledTextField/NRControlledTextField';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { useTheme } from '@mui/material/styles';
import { ModalMainContainer } from '../NRActionModal/NRActionModal';
import { hasValue } from '../../services/params.utils';
import { v4 as uuidv4 } from 'uuid';
import { useContext } from 'react';
import { AssetsContext } from '../../DataShare/NRAssetsDataShare';
import { forwardRef } from 'react';
const { CANCEL, CLOSE_TOOLTIP } = CONSTANTS.CONFIRMATION_MODAL;
const { YEAR_MONTH_DAY_TIME_DASHED } = CONSTANTS.DATE_FORMAT;
const { CREATED } = CONSTANTS.TRANSACTION_ASSET.LOCAL_STATUS;

function NRExportToCsvContent({ selectAllFetchConfig, totalCount, handleClose, isLoading = false, customRouteName }, ref) {
  const theme = useTheme();
  const { tasks, setTasks } = useContext(AssetsContext);
  const location = useLocation();
  const pathname = location.pathname;

  const routeName = customRouteName || pathname.split('/')?.at(-1)?.toLowerCase()?.replace('%20', '-');
  const downloadUrl = `download-csv/${routeName}`;
  const DEFAULT_VALUE = `${routeName}_export_${moment().format(YEAR_MONTH_DAY_TIME_DASHED)}.csv`;

  const { filter } = selectAllFetchConfig?.qlArgs;

  const filterHasValue = hasValue(filter) && Object.keys(filter).some(key => filter[key]);

  const emptyForm = {
    fileName: DEFAULT_VALUE
  };

  const methods = useForm({
    mode: 'onChange',
    shouldUnregister: false,
    defaultValues: emptyForm
  });

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = methods;

  const onSubmitHandler = form => {
    const { fileName } = form;

    let taskParams = {
      id: uuidv4(),
      type: CONSTANTS.TASKS.TYPE.DOWNLOAD_HTTP_POST,
      status: CREATED,
      fileName,
      downloadUrl,
      body: { fileName, ...selectAllFetchConfig?.qlArgs, filter: filter },
      headers: {},
      onSuccess: () => {},
      onError: () => {}
    };
    setTasks([taskParams, ...tasks]);
    handleClose();
  };

  return (
    <form ref={ref} tabIndex={-1} noValidate autoComplete="off" onSubmit={handleSubmit(onSubmitHandler)}>
      <ModalMainContainer width={500}>
        <Card elevation={0}>
          <CardHeader
            sx={{ paddingX: 3, paddingY: 2 }}
            title={<Typography variant={'h3'} children={'Export to CSV'} />}
            action={
              <Tooltip title={CLOSE_TOOLTIP} placement="right">
                <IconButton aria-label="Close" onClick={handleClose} size="large">
                  <X />
                </IconButton>
              </Tooltip>
            }
          />
          <CardContent sx={{ paddingX: 3, paddingBottom: 6, paddingTop: 3 }}>
            <FormControl fullWidth={true} sx={{ overflowX: 'auto', paddingTop: 1, marginTop: -1 }}>
              <NRControlledTextField
                variant="outlined"
                size="small"
                id="file-name"
                name="fileName"
                key="fileName"
                className={'classes.nameInput'}
                label={'File name'}
                helperText={(errors && errors['fileName']?.message) || '*Required'}
                control={control}
                defaultValue={DEFAULT_VALUE}
                rules={{
                  required: CONSTANTS.VALIDATIONS.REQUIRED
                }}
                error={!!errors['fileName']}
              />
            </FormControl>
            <Typography
              sx={{ paddingTop: 3, color: theme.palette.text.secondary }}
              variant={'body1'}
              children={`${filterHasValue ? 'Filtered' : 'Entire'} table (${totalCount} rows)`}
            />
          </CardContent>
          <CardActions
            sx={{
              paddingY: 1.75,
              paddingX: 3,
              justifyContent: 'flex-end',
              '& > :not(:first-of-type)': {
                marginLeft: 2
              }
            }}
          >
            <Button variant={'outlined'} color={'secondary'} onClick={() => handleClose()} sx={{ ml: 'auto' }}>
              {CANCEL}
            </Button>
            <Button variant="contained" type="submit" color="secondary" disabled={!totalCount || !!errors['fileName']}>
              Export
            </Button>
          </CardActions>
        </Card>
      </ModalMainContainer>
    </form>
  );
}

export default forwardRef(NRExportToCsvContent);
